import React from "react";
import PropTypes from "prop-types";
import { LoadingSpinner } from "cubee2e-cube-global-components";

export default function CommonLoader({ active }: { active: boolean }) {
  return (
    <div
      className={`fixed top-0 left-0 w-full h-full bg-white bg-opacity-80 flex justify-center items-center ${
        active ? "block" : "hidden"
      }`}
    >
      <LoadingSpinner variant="loading-spinner" />
    </div>
  );
}
CommonLoader.propTypes = {
  active: PropTypes.bool.isRequired,
};
